import { Spin } from 'antd'
import React from 'react'

export const DetailsLoader = () => {
  return (
    <div className='loader'>
      <Spin size='large' />
    </div>
  )
}
